import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { billingClient } from '#pplx_generated/typespec/rest/billing/client.js';
export const getComputerSubmitGate = async ({ reason, }) => {
    const { data, error, response } = await billingClient.GET('/rest/billing/credits/computer-submit-gate', reason, {
        headers: {
            'content-type': 'application/json',
        },
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to fetch computer submit gate',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=getComputerSubmitGate.js.map